export type FormState = {
  location: PerkRegion;
  category: string;
};

export enum PerkRegion {
  Global = 'Global',
  US = 'US',
}

export enum PerksModals {
  DISCLAIMER = 'disclaimer',
}
